import React from 'react'
import type { PaymentProof } from '@/types/paymentProof'

interface Props {
  proof: PaymentProof
  onViewDetail?: (proofId: string) => void
  onCancel?: (proofId: string) => void
}

const statusConfig: Record<string, { label: string; color: string; bg: string }> = {
  pending: { label: 'Menunggu Verifikasi', color: 'text-amber-700 dark:text-amber-400', bg: 'bg-amber-50 dark:bg-amber-500/10 border-amber-200 dark:border-amber-500/20' },
  approved: { label: 'Disetujui', color: 'text-emerald-700 dark:text-emerald-400', bg: 'bg-emerald-50 dark:bg-emerald-500/10 border-emerald-200 dark:border-emerald-500/20' },
  rejected: { label: 'Ditolak', color: 'text-red-700 dark:text-red-400', bg: 'bg-red-50 dark:bg-red-500/10 border-red-200 dark:border-red-500/20' },
  expired: { label: 'Kedaluwarsa', color: 'text-gray-500 dark:text-text-muted', bg: 'bg-gray-50 dark:bg-white/5 border-gray-200 dark:border-white/5' },
}

export const PaymentProofCard: React.FC<Props> = ({ proof, onViewDetail, onCancel }) => {
  const config = statusConfig[proof.status] || statusConfig.pending

  return (
    <div className={`border rounded-xl p-4 ${config.bg}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${config.color} ${config.bg}`}>
              {config.label}
            </span>
          </div>
          <p className="text-sm text-gray-700 dark:text-white font-medium">
            Rp {proof.amountPaid.toLocaleString('id-ID')}
          </p>
          <p className="text-xs text-gray-500 dark:text-text-muted mt-1">
            {proof.bankName} - {proof.accountNumber}
          </p>
          <p className="text-xs text-gray-500 dark:text-text-muted">
            {new Date(proof.createdAt).toLocaleDateString('id-ID', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })}
          </p>
          {proof.rejectionReason && (
            <p className="text-xs text-red-600 dark:text-red-400 mt-2 bg-red-50 dark:bg-red-500/10 p-2 rounded">
              Alasan penolakan: {proof.rejectionReason}
            </p>
          )}
        </div>
        <div className="flex flex-col gap-2">
          {onViewDetail && (
            <button
              onClick={() => onViewDetail(proof.id)}
              className="text-xs text-primary hover:opacity-75 font-medium"
            >
              Detail
            </button>
          )}
          {proof.status === 'pending' && onCancel && (
            <button
              onClick={() => onCancel(proof.id)}
              className="text-xs text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 font-medium"
            >
              Batalkan
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
